import { diContainer, serviceNames } from '../diContainer/diContainer';
import RedirectUserUseCase from '../use-cases/RedirectUserUseCase';
import normalizeApiErrors from '../helpers/normalizeApiErrors';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import { NOTIFICATION_GROUP } from '../constants/Notifications';
import { PaymentRepository } from '../repositories/PaymentRepository/PaymentRepository';

class ZeroPaymentUseCase {
  private paymentRepository: PaymentRepository;

  private notificationsCollection: NotificationsCollection;

  constructor() {
    this.paymentRepository = diContainer.get(serviceNames.paymentRepository);
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
  }

  public async execute(): Promise<void> {
    try {
      const data = await this.paymentRepository.verifyPayment();
      new RedirectUserUseCase(data.redirect).execute();
    } catch (error) {
      const normalizedErrors = error.errorResponse
        ? normalizeApiErrors(error, NOTIFICATION_GROUP.PAYMENT)
        : [error];
      this.notificationsCollection.addNotifications(normalizedErrors);
    }
  }
}

export default ZeroPaymentUseCase;
